var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['scrollbar-container', { 'always-overflow-y': _vm.alwaysOverflowY }]},[_c('div',{ref:"scrollbar",staticClass:"scrollbar"},[_vm._t("default"),(_vm.scrollToTopBtn)?_c('ScrollToTopBtn',{attrs:{"show":!_vm.atTop},on:{"click":_vm.scrollToTop}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }